import { Component } from '@angular/core';
import { PageNames } from 'src/app/configs/page-names.enum';
import { BaseSendQueueComponent } from './../base-send-queue/base-send-queue.component';

@Component({
  selector: 'app-current-user-send-queue',
  templateUrl: '../base-send-queue/base-send-queue.component.html',
  standalone: false,
})
export class CurrentUserSendQueueComponent extends BaseSendQueueComponent {
  pageTitle: string = 'pages.sendQueue.userTitle';
  tabName = PageNames.currentUserSendQueue;

  getPaginationApi() {
    this.setSelectedFields();
    const body = this.getBaseModelWithPaginationParams();

    return this.scheduledMessagesGQLService
      .getCurrentUserQueueWithPagination(
        {
          ...body,
        },
        this.selectedFields
      )
      .pipe(this.graphQlPipeOperators());
  }
}
